







































import mixins from 'vue-typed-mixins';
import { PageModeMixin } from '@/main/mixins/pageMode';

import { SkupinaProfilSelect } from '../../components';
import JinyPrijemceSelect from '../../components/microcomponents/JinyPrijemceSelect.vue';
import LeasingSelect from '../../components/microcomponents/LeasingSelect.vue';
import ProvozovnaSelect from '../../components/microcomponents/ProvozovnaSelect.vue';
import SlevaMaterialNumberInput from '../../components/microcomponents/SlevaMaterialNumberInput.vue';
import SmluvniPartnerSelect from '../../components/microcomponents/SmluvniPartnerSelect.vue';
import SmluvniPartnerTypSelect from '../../components/microcomponents/SmluvniPartnerTypSelect.vue';
import SlevaInputNumber from '../../components/microcomponents/SlevaInputNumer.vue';
import SDA from '../../components/microcomponents/SDA.vue';
import { EditMixin } from '../../mixins/editMixin';

export default mixins(PageModeMixin, EditMixin).extend({
	name: 'HlavniKarta',
	components: {
		SlevaMaterialNumberInput,
		ProvozovnaSelect,
		SkupinaProfilSelect,
		SmluvniPartnerTypSelect,
		SmluvniPartnerSelect,
		LeasingSelect,
		JinyPrijemceSelect,
		SlevaInputNumber,
		sda: SDA,
	},
	computed: {
		prevodMaxSuffix() {
			return ` (${this.PrevodMaxLimit ? this.PrevodMaxLimit : 0})`;
		},
		isCreateOrEditMode(): boolean {
			return this.isEditMode;
		},
	},
});
